export const pt_BR = {
    translation: {
        b: {
            cancel: 'Cancelar',
            confirm: 'Confirmar',
            send: 'Enviar',
            done: 'Concluído',
            close: 'Fechar',
            clear: 'Limpar',
            copy_link: 'Copiar link',
            export: 'Exportar',
            delete: 'Excluir',
            delete_confirm: 'Confirmar exclusão',
            duplicate: 'Duplicar',
            share: 'Compartilhar',
            sign_in: 'Entrar',
            sign_up: 'Cadastrar-se',
            email_address: 'Endereço de e-mail',
            yes: 'Sim',
            no: 'Não',
            back: 'Voltar',
            upgrade: 'Fazer upgrade',
            remove: 'Remover',
            restore: 'Restaurar',
            archive: 'Arquivar',
            rename: 'Renomear',
            leave: 'Sair',
            import: 'Importar',
            continue: 'Continuar',
            settings: 'Configurações',
            log_out: 'Sair da conta',
            invite: 'Convidar',
            invited: 'Convidado',
        },
        roles: {
            view: 'Leitor',
            comment: 'Comentarista',
            edit: 'Editor',
            admin: 'Admin',
            owner: 'Proprietário',
            member: 'Membro',
            remove: 'Remover',
            more_roles: 'Mais funções...',
            change_role: 'Alterar função...',
            remove_access: 'Remover acesso...',
            remove_invite: 'Remover convite...',
        },
        db_engine: {
            basic: 'SQL básico',
            general: 'SQL geral',
        },
        socket_status: {
            reconnecting: 'Reconectando...',
            offline: 'Você está offline. Reconectando...',
        },
        loader: {
            diagram: 'Carregando diagrama...',
        },
        m_languages: {
            title: 'Idiomas',
            subtitle: 'Escolha um idioma'
        },
        m_feedback: {
            feature: {
                name: 'Solicitação de recurso',
                desc: 'Faltando um recurso de que você precisa? Conte pra gente — suas ideias importam'
            },
            feedback: {
                name: 'Compartilhe seu feedback',
                desc: 'Adoraríamos saber o que você acha'
            },
            support: {
                name: 'Suporte',
                desc: 'Algo não está funcionando? Conte pra gente — vamos resolver rapidamente',
            },
            bug: {
                name: 'Reportar problema',
                desc: 'Algo não está certo? Reporte — vamos cuidar disso rapidamente',
            },
            integration: {
                name: 'Solicitar integração',
                desc: 'Seu feedback é muito importante para nós — deixe um recado rápido',
            }
        },
        m_feedback_t: {
            feature: {
                name: 'Obrigado pela sua sugestão!',
                desc: 'Agradecemos por dedicar um tempo para compartilhar suas ideias — isso nos ajuda a melhorar.'
            },
            feedback: {
                name: 'Obrigado pelo seu feedback!',
                desc: 'Agradecemos por dedicar um tempo para compartilhar suas ideias — isso nos ajuda a melhorar.'
            },
            support: {
                name: 'Obrigado por entrar em contato!',
                desc: 'Obrigado por contatar o suporte — vamos analisar sua solicitação e responder assim que possível.',
            },
            bug: {
                name: 'Obrigado pelo seu relato!',
                desc: 'Obrigado por relatar isso — isso nos ajuda a corrigir problemas mais rápido e melhorar a experiência continuamente.',
            },
            contact: {
                name: 'Obrigado por entrar em contato!',
                desc: 'Recebemos sua mensagem e vamos responder assim que possível.',
            },
            invite_people: {
                name: 'Convite enviado com sucesso!',
                desc: 'Obrigado por espalhar a novidade — estamos animados para dar as boas-vindas a eles.',
            },
            integration: {
                name: 'Obrigado pela sua sugestão!',
                desc: 'Agradecemos por dedicar um tempo para compartilhar suas ideias — isso nos ajuda a melhorar.',
            },
        },
        m_diagram_details: {
            name_place: 'Insira o nome do projeto',
            desc_place: 'Insira a descrição do projeto'
        },
        m_quick_share: {
            title: 'Compartilhar rápido',
            subtitle: '(Pelo link)'
        },
        m_export_img: {
            title: 'Exportar imagem'
        },
        search_menu: {
            placeholder: 'Buscar tabelas, colunas, tipos...',
            hint: '',
            no_results: 'Nenhum resultado',
            quick_results: 'Resultados rápidos para',
            untitled: 'sem título',
            command_tag: 'comando',
            section_tables: 'Tabelas',
            section_columns: 'Colunas',
            section_canvas: 'Área de trabalho',
            section_export: 'Exportar',
            section_preferences: 'Preferências',
            section_settings: 'Configurações',
            type_table: 'tabela',
            type_note: 'nota',
            cmd_new_table: 'Criar nova tabela...',
            cmd_new_note: 'Criar nova nota...',
            cmd_new_line: 'Criar nova linha...',
            cmd_new_area: 'Criar nova área...',
            cmd_export_image: 'Exportar imagem...',
            cmd_export_sql: 'Exportar código SQL...',
            cmd_grid_style: 'Alterar visualização em grade...',
        },
        canvas_table: {
            more_column: 'coluna a mais',
            more_columns: 'colunas a mais',
            tooltip_table: 'Tabela',
            tooltip_indexes: 'Índices',
            tooltip_enum: 'Enum',
            tooltip_default: 'Padrão',
            tooltip_generated: 'Gerado',
            tooltip_check: 'Check',
        },
        m_export_code: {
            title: 'Exportar código {{db_engine}}',
            download_file: 'Baixar arquivo',
            copy_code: 'Copiar código'
        },
        m_sign_in_remind: {
            title: 'Obrigado por experimentar o DB Design',
            subtitle: 'Entre ou cadastre-se para aumentar o número máximo de tabelas, salvar diagramas e desbloquear mais recursos.'
        },
        m_sign_in_restrict: {
            title: 'Entre para fazer mais no app',
            subtitle: 'Entre ou cadastre-se para aumentar os limites de tabelas, salvar diagramas e desbloquear mais recursos.'
        },
        m_new_diagram: {
            title: 'Novo diagrama',
            subtitle: 'Escolha um mecanismo de banco de dados',
            open_diagram: 'Abrir diagrama',
            create_diagram: 'Criar diagrama',
            no_workspace: 'Crie um espaço de trabalho primeiro para iniciar um diagrama.',
            build_something_new: 'Vamos criar algo novo',
            create_diagram_section: 'Criar diagrama',
            clone_template_btn: 'Duplicar modelo',
        },
        m_diagram_name: {
            enter_new_name: 'Insira um novo nome para o diagrama',
        },
        m_diagram_clone: {
            header: 'Duplicar diagrama',
            copy_of_title: 'Cópia de {{title}}',
        },
        m_diagram_rename: {
            header: 'Renomear diagrama',
        },
        m_template_clone: {
            header: 'Criar um diagrama a partir de um modelo',
        },
        m_diagram_delete: {
            header: 'Excluir diagrama',
            desc_prefix: 'Será excluído: ',
        },
        m_diagram_archive: {
            header: 'Arquivar diagrama',
            desc_prefix: 'Será arquivado: ',
        },
        m_diagram_restore: {
            header: 'Restaurar diagrama',
            desc_prefix: 'Será restaurado: ',
        },
        m_diagram_import: {
            sql_name: 'Importar código SQL',
            dbml_name: 'Importar código DBML',
            // NOTE: en.js flags this placeholder copy as mismatched content (reads like
            // feedback-modal copy, not an SQL/DBML paste prompt). Kept verbatim in
            // translation since fixing the copy is a product call, not a translation one.
            placeholder: 'Adoraríamos ouvir sua opinião!',
        },
        m_diagram_not_found: {
            header: 'Diagrama não encontrado',
            desc: 'Não conseguimos encontrar o diagrama que você procura.',
            back_to_app: 'Voltar ao app',
        },
        m_diagram_share: {
            header: 'Compartilhar diagrama – {{title}}',
            owner_only_invite: 'Somente o proprietário pode convidar novos membros',
            invited_to_workspace: 'Convidado para o espaço de trabalho',
            you: 'você',
            email_placeholder: 'Insira o e-mail',
            email_already_in_list: 'o e-mail já está na lista',
            will_be_invited_to_workspace: 'será convidado para o espaço de trabalho',
        },
        m_invite_people: {
            header: 'Convidar para o espaço de trabalho',
        },
        m_invite_revoke: {
            header: 'Remover convite',
            desc_prefix: 'Remover convite de ',
            desc_suffix: 'O convite deixará de funcionar.',
        },
        m_member_remove: {
            header: 'Remover membro',
            desc_prefix: 'Remover ',
            desc_suffix: ' deste espaço de trabalho? A pessoa perderá o acesso.',
        },
        m_template_details: {
            preview: 'Pré-visualização',
            use_template: 'Usar modelo',
        },
        m_workspace_create: {
            header: 'Criar um novo espaço de trabalho',
            name_label: 'Nome',
            setup_config_label: 'Configuração inicial',
            setup_config_value: 'Espaço de trabalho vazio',
            template_structure_label: 'Modelo/Estrutura',
            template_structure_value: 'Pré-carregar estrutura',
            placeholder: 'Insira o nome do espaço de trabalho',
            create_button: 'Criar espaço de trabalho',
            creating: 'Criando seu espaço de trabalho...',
        },
        m_workspace_delete: {
            header: 'Excluir espaço de trabalho',
            desc_prefix: 'Será excluído permanentemente: ',
            confirm_prefix: 'Digite ',
            confirm_suffix: ' para confirmar.',
        },
        m_workspace_leave: {
            header: 'Sair do espaço de trabalho',
            desc_prefix: 'Isso vai remover você de ',
            desc_suffix: '. Você precisará ser convidado novamente para voltar a participar.',
        },
        m_workspace_menu: {
            manage_members: 'Gerenciar membros',
            switch_workspace: 'Trocar espaço de trabalho',
            workspaces_label: 'Espaços de trabalho',
            create_workspace: 'Criar um espaço de trabalho...',
            switching: 'Trocando',
        },
        m_profile_menu: {
            profile: 'Perfil',
            onboarding: 'Primeiros passos',
        },
        m_pricing_limit: {
            admin_roles: { title: 'Leve sua colaboração para o próximo nível', description: 'Faça upgrade para desbloquear mais funções de compartilhamento como Admin, Editor, Comentarista e Leitor.' },
            workspaces: { title: 'Você está crescendo rápido!', description: 'Faça upgrade para criar e gerenciar mais espaços de trabalho para seus projetos e equipes.' },
            workspaces_canvas: { title: 'Expanda seus espaços de trabalho', description: 'Faça upgrade para criar e gerenciar mais espaços de trabalho para seus projetos e equipes.' },
            members: { title: 'Colabore em escala', description: 'Faça upgrade para trazer mais membros para o seu espaço de trabalho e colaborar de forma mais eficaz.' },
            diagrams: { title: 'Você está crescendo rápido!', description: 'Faça upgrade para criar mais diagramas e expandir seus projetos com confiança.' },
            tables: { title: 'Crie sem limites', description: 'Faça upgrade para adicionar mais tabelas e continuar criando diagramas maiores e mais detalhados.' },
            columns: { title: 'Crie sem limites', description: 'Faça upgrade para adicionar mais colunas e continuar criando diagramas maiores e mais detalhados.' },
            notes: { title: 'Crie sem limites', description: 'Faça upgrade para adicionar mais notas e continuar criando diagramas maiores e mais detalhados.' },
            areas: { title: 'Crie sem limites', description: 'Faça upgrade para adicionar mais áreas e continuar criando diagramas maiores e mais detalhados.' },
            pens: { title: 'Crie sem limites', description: 'Faça upgrade para adicionar mais desenhos e continuar criando diagramas maiores e mais detalhados.' },
            default_title: 'Leve sua colaboração para o próximo nível',
            default_title_canvas: 'Melhore o seu desempenho',
        },
        m_pricing_plans: {
            title: 'Fazer upgrade do seu plano',
            subtitle: 'Você sempre pode fazer upgrade ou downgrade do seu plano depois',
            monthly: 'Mensal',
            annually: 'Anual',
            billed_annually: 'Cobrança anual',
            billed_monthly: 'Cobrança mensal',
            free_for_everyone: 'Grátis para todos',
            current_plan: 'Plano atual',
            will_be_available_soon: 'Estará disponível em breve',
            price_period_user_month: '/usuário/mês',
            plan_free: {
                name: 'Grátis',
                button: 'Mudar de plano',
                feature_realtime: 'Colaboração em tempo real',
                feature_members: '4 membros / espaço de trabalho',
                feature_diagrams: '4 diagramas / espaço de trabalho',
                feature_tables: '40 tabelas / diagrama',
            },
            plan_pro: {
                name: 'Pro',
                feature_all_free: 'Todos os recursos do Grátis +',
                feature_members: 'Membros ilimitados',
                feature_diagrams: 'Diagramas ilimitados',
                feature_tables: 'Tabelas ilimitadas',
                feature_history: 'Histórico de versões',
                feature_admin_roles: 'Funções de admin',
            },
        },
        sidebar: {
            new: 'Novo',
            pinned_diagrams: 'Diagramas fixados',
            pin_hint: 'Fixe diagramas para vê-los aqui',
            expand_sidebar: 'Expandir barra lateral',
            home_aria: 'Início do DB Design',
            open_menu: 'Abrir menu',
            close_menu: 'Fechar menu',
            sidebar_menu_aria: 'Menu da barra lateral',
            plan_suffix: 'plano',
            diagram_options: 'Opções do diagrama',
            pin: 'Fixar',
            unpin: 'Desafixar',
            edit_details: 'Editar detalhes',
            see_details: 'Ver detalhes',
            invite_people: 'Convidar pessoas',
            collapse_sidebar: 'Recolher barra lateral',
            close_sidebar: 'Fechar barra lateral',
            open_sidebar: 'Abrir barra lateral',
            open_new_tab: 'Abrir em nova guia',
        },
        focus_controls: {
            show_top: 'Mostrar controles superiores',
            hide_top: 'Ocultar controles superiores',
            show_left: 'Mostrar controles esquerdos',
            hide_left: 'Ocultar controles esquerdos',
        },
        m_keyboard_shortcuts: {
            title: 'Atalhos de teclado',
            general: {
                title1: 'Geral',
                title2: '',
                items: {
                    new_diagram: 'Criar diagrama',
                    new_chat: 'Novo chat',
                    search: 'Ações rápidas ou pesquisa',
                    preferences: 'Preferências',
                    settings: 'Configurações',
                    keyboard_shortcuts: 'Atalhos de teclado',
                    toggle_sidebar: 'Mostrar/ocultar barra lateral',
                    toggle_theme: 'Alternar tema',
                },
            },
            ctrl_left: {
                title1: 'Controles',
                title2: '(Esquerda)',
                items: {
                    mouse_sel: 'Seleção com o mouse / Modo mão',
                    table: 'Tabela',
                    line: 'Linha',
                    area: 'Área',
                    note: 'Nota',
                    comment: 'Comentário',
                    pen: 'Lápis',
                    undo: 'Desfazer',
                    redo: 'Refazer'
                }
            },
            ctrl_top_left: {
                title1: 'Controles',
                title2: '(Canto superior esquerdo)',
                items: {
                    export_img: 'Exportar imagem',
                    search: 'Pesquisar',
                    editor_panel: 'Painel do editor',
                    zoom_to_fit: 'Ajustar à tela',
                }
            },
            ctrl_bottom_right: {
                title1: 'Controles',
                title2: '(Canto inferior direito)',
                items: {
                    minimap: 'Minimapa',
                    full_screen: 'Tela cheia',
                    zoom_in: 'Ampliar',
                    zoom_out: 'Reduzir',
                    zoom_100: 'Zoom 100%'
                }
            },
            ctx_tab: {
                title1: 'Menu de contexto',
                title2: '(Tabela)',
                items: {
                    dupl_tab: 'Duplicar tabela',
                    del_tab: 'Excluir tabela'
                }
            },
            ctx_del_tab: {
                title1: 'Menu de contexto',
                title2: '(Excluir tabela)',
                items: {
                    yes: 'Sim',
                    no: 'Não'
                }
            },
            ctx_tab_col: {
                title1: 'Menu de contexto',
                title2: '(Coluna)',
                items: {
                    add_col_below: 'Adicionar coluna abaixo',
                    focus_col_above: 'Mover o foco para a coluna acima',
                    focus_col_below: 'Mover o foco para a coluna abaixo',
                    move_col_up: 'Mover coluna para cima',
                    move_col_down: 'Mover coluna para baixo',
                    dupl_col: 'Duplicar coluna',
                    del_col: 'Excluir coluna'
                }
            },
            ctx_line: {
                title1: 'Menu de contexto',
                title2: '(Linha)',
                items: {
                    del_line: 'Excluir linha'
                }
            },
            ctx_area: {
                title1: 'Menu de contexto',
                title2: '(Área)',
                items: {
                    dupl_area: 'Duplicar área',
                    del_area: 'Excluir área'
                }
            },
            ctx_multi: {
                title1: 'Menu de contexto',
                title2: '(Multisseleção)',
                items: {
                    select_all: 'Selecionar todos os elementos',
                    create_area_for_select_els: 'Criar área para elementos selecionados',
                    dupl_select_els: 'Duplicar elementos selecionados',
                    del_select_els: 'Excluir elementos selecionados'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: 'Seleção do mouse',
                table: 'Tabela',
                line: 'Linha',
                area: 'Área',
                note: 'Nota',
                comment: 'Comentário',
                pen: 'Lápis',
                undo: 'Desfazer',
                redo: 'Refazer'
            },
            ctrl_top_left: {
                home: 'Início',
                name: 'Informações do diagrama',
                editor: 'Editor',
                search: 'Pesquisa',
                export: 'Opções de exportação',
                view_mode: 'Modo de visualização',
                zoom_to_fit: 'Ajustar à tela',
                grid: 'Visualização em grade',
                history: 'Histórico',
                main_menu: 'Menu principal',
                new_diagram: 'Novo diagrama',
            },
            ctrl_top_right: {
                feature_req: 'Solicitação de recurso',
                feedback: 'Enviar feedback',
                sign_in: 'Entrar',
                quick_share: 'Compartilhar rápido'
            },
            ctrl_bottom_right: {
                full_screen: 'Tela cheia',
                minimap: 'Minimapa',
                zoom_out: 'Reduzir',
                zoom_100: 'Zoom 100%',
                zoom_in: 'Ampliar',
                info: 'Informações e recursos'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'Padrão',
                        blue: 'Azul',
                        green: 'Verde',
                        red: 'Vermelho',
                        purple: 'Roxo',
                        violet: 'Violeta'
                    },
                    borders: {
                        none: 'Nenhuma',
                        solid: 'Sólida',
                        dashed: 'Tracejada',
                        dotted: 'Pontilhada'
                    },
                    color: 'Cor',
                    border: 'Borda',
                    description: 'Descrição',
                    description_table_place: 'Descrição da tabela',
                    description_column_place: 'Descrição da coluna',
                    description_line_place: 'Descrição da linha',
                    description_note_place: 'Descrição da nota',
                    description_area_place: 'Descrição da área',
                    description_pen_place: 'Descrição do lápis',
                    hide_menu: 'Ocultar menu',
                    show_menu: 'Mostrar menu'
                },
                tab_col: {
                    add_col_below: 'Adicionar coluna abaixo',
                    add_col_above: 'Adicionar coluna acima',
                    key: 'Key',
                    keys: {
                        none: 'Nenhuma',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'Nenhum',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'Mover coluna para baixo',
                    move_col_up: 'Mover coluna para cima',
                    more_functions: 'Mais funções'
                },
                line: {
                    change_connects: 'Alterar conectores',
                    connects: {
                        empty: 'Vazio',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_many_to: 'One or Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update Trigger',
                    on_delete: 'On Delete Trigger'
                },
                area: {
                    filter: 'Filtrar elementos'
                },
                note: {
                    link_placeholder: 'Insira um link',
                    link_apply: 'Adicionar',
                    link_remove: 'Remover',
                    link_edit: 'Editar',
                    link_needs_selection: 'Selecione o texto para vincular',
                    bulleted_list: 'Lista',
                    numbered_list: 'Lista numerada',
                    font_style: 'Estilo da fonte',
                    alignment: 'Alinhamento',
                    align_left: 'Esquerda',
                    align_center: 'Centro',
                    align_right: 'Direita',
                    link: 'Link',
                    monospace: 'Monoespaçada',
                    bold: 'Negrito',
                    italic: 'Itálico',
                    underline: 'Sublinhado',
                    strikethrough: 'Tachado',
                },
                multi: {
                    filter: 'Filtrar seleção',
                    create_area: 'Criar área'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'Completo',
            keys_only: 'Somente chaves',
            names_only: 'Somente nomes'
        },
        dropdown_ctrl_grid: {
            none: 'Nenhum',
            lines: 'Linhas',
            dots: 'Pontos',
        },
        dropdown_ctrl_export: {
            export_img: 'Exportar imagem',
            export_code: 'Exportar código SQL'
        },
        dropdown_ctrl_settings: {
            back_home: 'Voltar ao início',
            sign_in: 'Entrar',
            preferences: 'Preferências',
            new_project: 'Novo projeto',
            import_diagram: 'Importar diagrama',
            duplicate_diagram: 'Duplicar diagrama',
            keyboard_shortcuts: 'Atalhos de teclado',
            languages: 'Idiomas',
            view: 'Visualização',
            upgrade_plan: 'Fazer upgrade do plano',
            language: 'Idioma',
            mouse_trackpad: 'Mouse ou trackpad',
            background_color: 'Cor de fundo',
            grid_layout: 'Layout da grade',
            view_mode: 'Modo de visualização',
            show_align_lines: 'Mostrar linhas de alinhamento',
            show_members_cursors: 'Mostrar cursores dos membros',
            show_comments: 'Mostrar comentários',
            undo_redo_controls: 'Controles de desfazer/refazer',
            show_scrollbars: 'Mostrar barras de rolagem',
            opt_auto: 'Automático',
            opt_trackpad: 'Trackpad',
            opt_mouse: 'Mouse',
            opt_default: 'Escuro (padrão)',
            opt_gray: 'Cinza',
            opt_blue: 'Azul',
            opt_purple: 'Roxo',
            opt_violet: 'Violeta',
            opt_green: 'Verde',
            opt_red: 'Vermelho',
            opt_yellow: 'Amarelo',
            opt_dots: 'Pontos',
            opt_lines: 'Linhas',
            opt_none: 'Nenhum',
            opt_full: 'Completo',
            opt_keys: 'Chaves',
            opt_names: 'Nomes',
        },
        dropdown_ctrl_info_resources: {
            feedback: 'Enviar feedback',
            keyboard_shortcuts: 'Atalhos de teclado',
            languages: 'Idiomas',
            homepage: 'Página inicial'
        },
        n: {
            default: 'Carregando…',
            file_ready_to_download: 'O arquivo está pronto para download',
            code_copied: 'O código foi copiado',
            link_copied: 'O link foi copiado',
            username_copied: 'Nome de usuário copiado para a área de transferência',
            email_copied: 'E-mail copiado para a área de transferência',
            please_enter_message: 'Insira uma mensagem',
            invalid_email: 'E-mail inválido',
            note_link_unsupported_protocol: 'Tipo de link não suportado. Use https, http, mailto.',
            something_wrong_contact: 'Algo deu errado. Tente recarregar a página ou fale conosco.',
            something_wrong: 'Algo deu errado. Tente recarregar a página.',
            sending: 'Enviando…',
            request_sent: 'A solicitação foi enviada. Obrigado!',

            please_enter_email: 'Insira o endereço de e-mail',
            changing: 'Alterando...',
            role_changed: 'Função alterada',
            removing: 'Removendo...',
            member_removed: 'Membro removido',
            inviting: 'Convidando...',
            invite_sent: 'Convite enviado',
            added_to_diagram: 'Adicionado ao diagrama',
            invite_removed: 'Convite removido',
            role_not_allowed_on_plan: 'Essa função não está disponível no seu plano. Faça upgrade para atribuí-la.',
            already_diagram_member: 'Essa pessoa já tem acesso ao diagrama.',
            cannot_invite_to_workspace: 'Peça a um admin do espaço de trabalho para convidar essa pessoa.',
            saving: 'Salvando...',
            saved: 'Salvo',
            diagram_renamed: 'Diagrama renomeado',
            diagram_updated: 'Diagrama atualizado',
            duplicating: 'Duplicando...',
            diagram_duplicated: 'Diagrama duplicado',
            deleting: 'Excluindo...',
            diagram_archived: 'Diagrama arquivado',
            diagram_deleted: 'Diagrama excluído',
            restoring: 'Restaurando...',
            diagram_restored: 'Diagrama restaurado',
            diagram_pinned: 'Diagrama fixado',
            diagram_unpinned: 'Diagrama desafixado',
            creating: 'Criando...',
            diagram_created: 'Diagrama criado',
            forbidden: 'Você não tem acesso a isso.',
            invite_already_pending: 'This person already has a pending invitation.',
            already_member: 'Já é membro do espaço de trabalho',
            cannot_invite_self: 'Você não pode se convidar',
            workspace_not_found: 'Workspace not found. Refresh the page and try again.',
            diagram_not_found: 'Diagrama não encontrado.',
            has_diagram_members: 'O diagrama tem membros ativos',
            seat_limit_reached: 'Você atingiu o limite de vagas do seu plano. Faça upgrade para convidar mais pessoas.',
            feature_not_in_plan: 'Esse recurso não está incluído no seu plano atual.',
            subscription_expired: 'Sua assinatura expirou. Renove para continuar usando.',
            subscription_inactive: 'Sua assinatura está inativa. Atualize seus dados de cobrança.',
            plan_limit_generic: 'Seu plano não permite essa ação. Faça upgrade para continuar.',

            // Auth / profile
            session_expired: 'Sua sessão expirou — faça login novamente.',
            profile_updated: 'Perfil atualizado',
            profile_update_failed: 'Falha ao atualizar o perfil.',
            account_delete_failed: 'Falha ao excluir a conta.',

            // Preferences
            couldnt_save: 'Não foi possível salvar as alterações',
            try_again: 'Algo deu errado. Tente novamente.',

            // Workspace
            not_workspace_member: 'Você não é membro desse espaço de trabalho.',
            workspace_switch_failed: 'Não foi possível trocar de espaço de trabalho. Tente novamente.',
            workspace_create_failed: 'Não foi possível criar o espaço de trabalho. Tente novamente.',
            invalid_workspace_name: 'Nome de espaço de trabalho inválido',
            workspace_updated: 'Espaço de trabalho atualizado',
            workspace_update_failed: 'Não foi possível atualizar o espaço de trabalho. Tente novamente.',
            last_owner_cannot_leave: 'Você é o único proprietário. Torne outra pessoa proprietária ou exclua o espaço de trabalho antes de sair.',
            workspace_leave_failed: 'Não foi possível sair do espaço de trabalho. Tente novamente.',
            workspace_delete_forbidden: 'Somente o proprietário do espaço de trabalho pode excluí-lo.',
            workspace_has_active_billing: 'Cancele a assinatura deste espaço de trabalho antes de excluí-lo.',
            workspace_deleted: 'Espaço de trabalho excluído',
            workspace_delete_failed: 'Não foi possível excluir o espaço de trabalho. Tente novamente.',
            member_remove_forbidden: 'Você não tem permissão para remover esse membro.',
            member_remove_failed: 'Não foi possível remover o membro. Tente novamente.',
            cannot_remove_self: 'Use "Sair do espaço de trabalho" para se remover.',
            cannot_remove_last_owner: 'Um espaço de trabalho sempre precisa ter um proprietário. Torne outra pessoa proprietária primeiro.',
            invite_revoke_forbidden: 'Você não tem permissão para revogar esse convite.',
            invite_revoke_failed: 'Não foi possível revogar o convite. Tente novamente.',
        },
        dashboard: {
            doc_title: 'Diagramas',
            filter_all: 'Todos',
            filter_mydiagrams: 'Meus diagramas',
            filter_shared: 'Compartilhados comigo',
            filter_archived: 'Arquivados',
            empty_all: 'Nenhum diagrama em "Todos os diagramas"',
            empty_mydiagrams: 'Nenhum diagrama em "Meus diagramas"',
            empty_shared: 'Nenhum diagrama em "Compartilhados comigo"',
            empty_archived: 'Nenhum diagrama em "Arquivados"',
            example_diagram_badge: 'Diagrama de exemplo',
            import_sql: 'SQL',
            import_dbml: 'DBML',
            import_playground: 'Playground',
        },
        settings_page: {
            nav: {
                back_to_app: 'Voltar ao app',
                group_personal: 'Pessoal',
                group_organization: 'Organização',
                billing: 'Faturamento',
            },
            profile: {
                member_since: 'Membro desde {{date}}',
                general: 'Geral',
                email: 'E-mail',
                full_name: 'Nome completo',
                full_name_placeholder: 'Digite o nome',
                account_protection: 'Proteção da conta',
                mfa_label: 'Autenticação multifator (MFA)',
                mfa_sub: 'Camada extra de segurança para a conta · Em breve',
                mfa_enable: 'Ativar MFA',
                mfa_soon_tooltip: 'Estará disponível em breve',
                workspace_access: 'Acesso ao espaço de trabalho',
                leave_workspace: 'Sair do espaço de trabalho',
                leave_workspace_sub: 'Remover você do espaço de trabalho',
                leave_owner_tooltip: 'Transfira a propriedade antes de sair do espaço de trabalho',
            },
            workspace: {
                header: 'Espaço de trabalho',
                general: 'Geral',
                name_label: 'Nome do espaço de trabalho',
                name_placeholder: 'nome do espaço de trabalho',
                stat_member_singular: 'Membro',
                stat_member_plural: 'Membros',
                stat_team_singular: 'Equipe',
                stat_team_plural: 'Equipes',
                members_section: 'Membros',
                no_members: 'Nenhum membro',
                count_member_singular: 'membro',
                count_member_plural: 'membros',
                view_members_btn: 'Ver membros',
                danger_zone: 'Zona de risco',
                delete_workspace: 'Excluir espaço de trabalho',
                delete_workspace_sub: 'Isso excluirá permanentemente o espaço de trabalho',
                delete_owner_only_tooltip: 'Somente proprietários podem excluir espaços de trabalho',
                delete_cancel_sub_tooltip: 'Cancele sua assinatura antes de excluir o espaço de trabalho',
            },
            members: {
                header: 'Membros',
                col_name: 'Nome',
                col_email: 'E-mail',
                col_role: 'Função',
                col_joined: 'Ingressou em',
                active_members: 'Membros ativos',
                invited_section: 'Convidados',
                no_members: 'Ainda não há membros.',
                options_aria: 'Opções',
                leave_workspace_item: 'Sair do espaço de trabalho...',
                remove_member_item: 'Remover membro...',
                remove_owner_only_tooltip: 'Somente proprietários podem remover membros',
                remove_owner_row_tooltip: 'O proprietário não pode ser removido do espaço de trabalho',
                remove_invite_item: 'Remover convite...',
                role_invited_suffix: '{{role}} (Convidado)',
            },
            preferences: {
                section_general: 'Geral',
                section_diagram_defaults: 'Configurações do diagrama',
                section_diagram_views: 'Visualizações do diagrama',
                section_notifications: 'Notificações',
                theme_label: 'Tema da interface',
                theme_sub: 'Selecione o esquema de cores da interface',
                theme_dark: 'Escuro',
                theme_light: 'Claro',
                theme_system: 'Sistema',
                language_sub: 'Selecione o idioma da interface',
                timezone_label: 'Fuso horário',
                timezone_sub: 'Selecione seu fuso horário',
                timezone_options: {
                    honolulu: 'GMT-10:00 — Havaí',
                    anchorage: 'GMT-09:00 — Alasca',
                    los_angeles: 'GMT-08:00 — Horário do Pacífico',
                    denver: 'GMT-07:00 — Horário das Montanhas',
                    chicago: 'GMT-06:00 — Horário Central',
                    new_york: 'GMT-05:00 — Horário Oriental',
                    caracas: 'GMT-04:00 — Caracas',
                    sao_paulo: 'GMT-03:00 — São Paulo',
                    azores: 'GMT-01:00 — Açores',
                    london: 'GMT+00:00 — Londres',
                    paris: 'GMT+01:00 — Paris, Berlim',
                    kyiv: 'GMT+02:00 — Kyiv, Atenas',
                    istanbul: 'GMT+03:00 — Istambul',
                    dubai: 'GMT+04:00 — Dubai',
                    karachi: 'GMT+05:00 — Carachi',
                    kolkata: 'GMT+05:30 — Índia',
                    dhaka: 'GMT+06:00 — Daca',
                    bangkok: 'GMT+07:00 — Bangkok, Jacarta',
                    shanghai: 'GMT+08:00 — Pequim, Singapura',
                    tokyo: 'GMT+09:00 — Tóquio, Seul',
                    sydney: 'GMT+10:00 — Sydney',
                    auckland: 'GMT+12:00 — Auckland',
                },
                input_mode_sub: 'Escolha os controles de navegação da tela',
                background_sub: 'Escolha uma cor de fundo para a tela',
                grid_sub: 'Escolha o layout da grade da tela',
                show_align_lines_sub: 'Mostrar linhas ao alinhar objetos',
                show_cursors_sub: 'Mostrar cursores de outros colaboradores',
                show_comments_sub: 'Mostrar comentários na tela',
                show_scrollbars_sub: 'Mostrar barras de rolagem ao navegar na tela',
                show_undo_redo_label: 'Mostrar controles de desfazer/refazer',
                show_undo_redo_sub: 'Mostrar controles para desfazer e refazer alterações',
                notif_shared_label: 'Diagrama compartilhado comigo',
                notif_shared_sub: 'Quando alguém compartilha um diagrama comigo',
                notif_mentions_label: 'Menções em comentários',
                notif_mentions_sub: 'Quando alguém me menciona com @ em um comentário',
                notif_updates_label: 'Novidades do produto',
                notif_updates_sub: 'Atualizações mensais sobre novos recursos e melhorias',
                show: 'Mostrar',
                hide: 'Ocultar',
                on: 'Ativado',
                off: 'Desativado',
            },
            billing: {
                header: 'Faturamento',
                plan_free: 'Plano gratuito',
                status_current: 'Atual',
                no_renewal_needed: 'Nenhuma renovação necessária',
                payment_header: 'Pagamento',
                no_payments: 'Nenhum pagamento',
                invoices_header: 'Faturas',
                no_invoices: 'Nenhuma fatura',
            },
            usage: {
                doc_title: 'Uso',
                overview_title: 'Visão geral',
                resource_limits_title: 'Limites de recursos',
                label_diagrams: 'Diagramas',
                label_tables: 'Tabelas',
                label_areas: 'Áreas',
                label_notes: 'Notas adesivas',
                label_members: 'Membros',
                label_tables_per_diagram: 'Tabelas / Diagrama',
                label_areas_per_diagram: 'Áreas / Diagrama',
                label_notes_per_diagram: 'Notas / Diagrama',
                need_more_title: 'Precisa de mais?',
                need_more_free: 'Faça upgrade para o Basic e tenha mais diagramas, histórico de versões e suporte prioritário.',
                need_more_paid: 'Faça upgrade para o Professional e tenha diagramas ilimitados, mais vagas e recursos avançados.',
            },
        },
        pages: {
            not_found: {
                page_not_found: 'Página não encontrada',
                dont_have_access_to_diagram: 'Você não tem acesso a este diagrama ou ele pode não existir mais.',
                back_home: 'Voltar ao início'
            },
            error: {
                title: 'Erro',
                link_is_invalid: 'Este link é inválido ou foi digitado incorretamente.',
                something_wrong: 'Algo deu errado.',
                back_home: 'Voltar ao início',
                please_try_later: 'Tente novamente mais tarde',
            },
            billing_success: {
                doc_title: 'Plano atualizado',
                heading: 'Pagamento realizado com sucesso',
                subtitle: 'Seu plano foi atualizado com sucesso.',
                cta: 'Começar a criar',
            },
            email_verified: {
                doc_title: 'E-mail verificado',
            },
            forgot_password: {
                doc_title: 'Esqueci minha senha',
            },
            password_updated: {
                doc_title: 'Senha atualizada',
            },
            reset_password: {
                doc_title: 'Redefinir senha',
            },
            check_email: {
                doc_title: 'Verifique seu e-mail',
            },
            sign_in: {
                doc_title: 'Entrar no {{product}}',
            },
            sign_up: {
                doc_title: 'Cadastre-se no {{product}}',
            },
        },
    }
};

export const pt_BRMeta = {
    lang_origin: 'Português',
    lang_eng: 'Portuguese',
    lang_code: 'pt-BR',
};
